import { createStyles } from '@mantine/emotion';

export const useStylesNotification = createStyles(() => ({
    root: {
        borderRadius: '0',
        border: 'none',
        backgroundColor: 'var(--notification-color, var(--mantine-primary-color-filled))',
        '&::before': {
            backgroundColor: 'var(--mantine-color-nli-yankees-blue-filled)',
        },
        boxShadow: '4px 4px 8px #000',
    },
    description: {
        color: 'var(--mantine-color-nli-yankees-blue-filled)',
        fontSize: 'var(--font-size-md)',
        textAlign: 'center',
    },
    title: {
        color: 'var(--mantine-color-nli-yankees-blue-filled)',
    },
    closeButton: {
        color: 'var(--mantine-color-nli-yankees-blue-filled)',
        '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.1)',
        },
    },
}));